import React, { createContext, useContext, useState, useCallback } from 'react';

const ContactModalContext = createContext(null);

export function ContactModalProvider({ children }) {
  const [showContact, setShowContact] = useState(false);

  const openContact = useCallback(() => setShowContact(true), []);
  const closeContact = useCallback(() => setShowContact(false), []);

  return (
    <ContactModalContext.Provider value={{ showContact, openContact, closeContact }}>
      {children}
    </ContactModalContext.Provider>
  );
}

export function useContactModal() {
  const ctx = useContext(ContactModalContext);
  if (!ctx) throw new Error('useContactModal must be used within ContactModalProvider');
  return ctx;
}

export default ContactModalContext;
